import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import DocsSidebar from '../components/DocsSidebar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'
import SiteNav from '../components/SiteNav'
import { DOCS_NAV_ITEMS, docsSections, filterDocs } from '../lib/docsCatalog'
import '../styles/docs.css'

function SearchIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="m21 21-4.3-4.3M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.8}
      />
    </svg>
  )
}

export default function Docs() {
  const [query, setQuery] = useState('')
  const visibleItems = useMemo(() => filterDocs(query), [query])
  const sections = query.trim()
    ? [{ title: 'Search results', items: visibleItems }]
    : docsSections(DOCS_NAV_ITEMS)

  return (
    <>
      <SEO
        title="TokenDance Docs"
        description="TokenDance docs for forward deployed engineering, LLM APIs, model routing, evals, and production AI operations."
        path="/docs"
      />
      <div className="od-docs-page">
        <SiteNav />
        <div className="od-docs-frame">
          <DocsSidebar />

          <main className="od-docs-main">
            <header className="od-docs-home-hero">
              <p className="od-docs-kicker">TokenDance Docs</p>
              <h1>FDE teams and LLM infrastructure for production AI.</h1>
              <p>
                Search by what you need to ship: forward-deployed engineering,
                model APIs, structured outputs, evaluation loops, GPU inference,
                or operational runbooks.
              </p>

              <label className="od-docs-home-search">
                <SearchIcon />
                <input
                  value={query}
                  onChange={(event) => setQuery(event.target.value)}
                  placeholder="Search FDE, LLM, evals, GPU, agents..."
                />
              </label>
            </header>

            <section id="docs-library" className="od-docs-section od-docs-section--first">
              <div className="od-docs-section-copy">
                <p className="od-docs-kicker">Guides</p>
                <h2>{query.trim() ? 'Search results' : 'Choose a guide'}</h2>
                <p>
                  These guides explain how TokenDance scopes, builds, and operates AI systems
                  with embedded engineers and a managed LLM infrastructure layer.
                </p>
              </div>

              <div className="od-docs-library" aria-label="Documentation pages">
                {sections.map((section) => (
                  <article key={section.title} className="od-docs-library-section">
                    <div className="od-docs-library-head">
                      <h3>{section.title}</h3>
                      <span>{section.items.length} {section.items.length === 1 ? 'guide' : 'guides'}</span>
                    </div>
                    {section.items.length === 0 ? (
                      <p className="od-docs-empty">No docs match that search.</p>
                    ) : (
                      <div className="od-docs-library-list">
                        {section.items.map((item) => (
                          <Link key={item.href} to={item.href} className="od-docs-library-row">
                            <span className="od-docs-row-copy">
                              <strong>{item.title}</strong>
                              <span>{item.description}</span>
                            </span>
                          </Link>
                        ))}
                      </div>
                    )}
                  </article>
                ))}
              </div>
            </section>
          </main>
        </div>
        <Footer />
      </div>
    </>
  )
}
